import { useEffect, useState } from 'react';
import AppLayout from '@/components/feature/AppLayout';

const ratingColor = (r: string) =>
  r === 'excellent'
    ? 'bg-green-100 text-green-700'
    : r === 'good'
    ? 'bg-teal-100 text-teal-700'
    : 'bg-red-100 text-red-700';

export default function SupPerformancePage() {

  const [performanceData, setPerformanceData] =
    useState<any[]>([]);

  const [recentActivities, setRecentActivities] =
    useState<any[]>([]);

  const [dashboardStats, setDashboardStats] =
    useState({

      overdue: 0,
      avgResponse: '1.4',
      avgResolution: '43'

    });

  useEffect(() => {

    fetch(
      'https://guardiancloudcare.com/backend/api/get_performance_monitoring.php'
    )
    .then(res => res.json())
    .then(data => {

      if (data.performance) {

        setPerformanceData(data.performance);

      }

      if (data.activities) {

        setRecentActivities(data.activities);

      }

      if (data.stats) {

        setDashboardStats(data.stats);

      }

    });

  }, []);

  return (

    <AppLayout
      title="Performance Monitoring"
      breadcrumb={['Supervisor', 'Performance']}
    >

      <div className="space-y-4">

        <div className="grid grid-cols-3 gap-4">

          {[
            {
              label: 'Avg Response Time',
              value: `${dashboardStats.avgResponse} days`,
              icon: 'ri-time-line',
              color: 'text-teal-600',
              bg: 'bg-teal-50'
            },
            {
              label: 'Avg Resolution Time',
              value: `${dashboardStats.avgResolution} days`,
              icon: 'ri-calendar-check-line',
              color: 'text-amber-600',
              bg: 'bg-amber-50'
            },
            {
              label: 'Overdue Cases',
              value: dashboardStats.overdue,
              icon: 'ri-alarm-warning-line',
              color: 'text-red-600',
              bg: 'bg-red-50'
            }
          ].map((k) => (

            <div
              key={k.label}
              className="bg-white rounded-xl border border-gray-100 p-5"
            >

              <div className={`w-10 h-10 ${k.bg} rounded-xl flex items-center justify-center mb-3`}>

                <i className={`${k.icon} ${k.color} text-lg`} />

              </div>

              <p className="text-2xl font-bold text-gray-900">
                {k.value}
              </p>

              <p className="text-sm text-gray-500 mt-1">
                {k.label}
              </p>

            </div>

          ))}

        </div>

        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">

          <div className="px-5 py-4 border-b border-gray-100">

            <h3 className="font-semibold text-gray-800">
              Social Worker Performance Report
            </h3>

            <p className="text-xs text-gray-400 mt-0.5">
              Response time, resolution time, and overdue case tracking
            </p>

          </div>

          <div className="overflow-x-auto">

            <table className="w-full text-sm">

              <thead>

                <tr className="bg-gray-50 text-xs text-gray-500 uppercase tracking-wide">

                  <th className="px-5 py-3 text-left font-medium">
                    Worker
                  </th>

                  <th className="px-5 py-3 text-left font-medium">
                    Total
                  </th>

                  <th className="px-5 py-3 text-left font-medium">
                    Closed
                  </th>

                  <th className="px-5 py-3 text-left font-medium">
                    Pending
                  </th>

                  <th className="px-5 py-3 text-left font-medium">
                    Avg Response
                  </th>

                  <th className="px-5 py-3 text-left font-medium">
                    Avg Resolution
                  </th>

                  <th className="px-5 py-3 text-left font-medium">
                    Overdue
                  </th>

                  <th className="px-5 py-3 text-left font-medium">
                    Rating
                  </th>

                </tr>

              </thead>

              <tbody className="divide-y divide-gray-50">

                {performanceData.map((m) => (

                  <tr
                    key={m.uid}
                    className={`hover:bg-gray-50 transition-colors ${
                      m.overdueCount > 0
                        ? 'bg-red-50/20'
                        : ''
                    }`}
                  >

                    <td className="px-5 py-3">

                      <div className="flex items-center gap-2">

                        <div className="w-8 h-8 rounded-full bg-teal-500 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">

                          {m.name
                            .split(' ')
                            .map((n: string) => n[0])
                            .join('')}

                        </div>

                        <div>

                          <p className="text-sm font-medium text-gray-800">

                            {m.name}

                          </p>

                          <p className="text-xs text-gray-400">

                            Last active:
                            {' '}
                            {m.lastActivity || 'No Activity'}

                          </p>

                        </div>

                      </div>

                    </td>

                    <td className="px-5 py-3 text-sm font-bold text-gray-900">

                      {m.totalCases}

                    </td>

                    <td className="px-5 py-3 text-sm text-teal-600 font-medium">

                      {m.closedCases}

                    </td>

                    <td className="px-5 py-3 text-sm text-amber-600 font-medium">

                      {m.pendingCases}

                    </td>

                    <td className="px-5 py-3 text-sm text-gray-700">

                      {m.avgResponseDays} days

                    </td>

                    <td className="px-5 py-3 text-sm text-gray-700">

                      {m.avgResolutionDays} days

                    </td>

                    <td className="px-5 py-3">

                      {m.overdueCount > 0 ? (

                        <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full font-medium">

                          {m.overdueCount} overdue

                        </span>

                      ) : (

                        <span className="text-xs text-green-600">

                          None

                        </span>

                      )}

                    </td>

                    <td className="px-5 py-3">

                      <span
                        className={`text-xs px-2 py-1 rounded-full font-medium capitalize ${ratingColor(m.rating)}`}
                      >

                        {m.rating}

                      </span>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        </div>

        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">

          <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">

            <h3 className="font-semibold text-gray-800">
              Recent Activity Log
            </h3>

            <span className="text-xs text-gray-400">
              Visible to supervisor for accountability
            </span>

          </div>

          <div className="divide-y divide-gray-50">

            {recentActivities.map((a) => (

              <div
                key={a.id}
                className={`px-5 py-4 flex items-center gap-4 ${
                  a.delayDays > 0
                    ? 'bg-red-50/30'
                    : ''
                }`}
              >

                <div
                  className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                    a.delayDays > 0
                      ? 'bg-red-100'
                      : 'bg-teal-50'
                  }`}
                >

                  <i
                    className={`text-sm ${
                      a.delayDays > 0
                        ? 'ri-alarm-warning-line text-red-500'
                        : 'ri-checkbox-circle-line text-teal-500'
                    }`}
                  />

                </div>

                <div className="flex-1">

                  <p className="text-sm font-medium text-gray-800">

                    {a.worker_name}

                  </p>

                  <p className="text-xs text-gray-500">

                    {a.title}

                  </p>

                  <p className="text-xs font-mono text-gray-400">

                    {a.case_number}
                    {' · '}
                    {a.created_at}

                  </p>

                </div>

                {a.delayDays > 0 && (

                  <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full font-medium">

                    {a.delayDays}d delay

                  </span>

                )}

              </div>

            ))}

          </div>

        </div>

      </div>

    </AppLayout>

  );

}